import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import { useDeepCompareEffect } from './use-deep-compare-effect';
import { useDispatch } from 'react-redux';
import { usePaginationSelector } from 'store/modules/pagination/pagination.selector';
import {
  setPageNumber,
  setTotalItems,
} from 'store/modules/pagination/pagination.reducer';
// import { setTableTotalItems } from 'store/modules/selected-column/selected-column.reducer';
// import { useSelectedColumnSelector } from 'store/modules/selected-column/selected-column.selector';

interface Props {
  baseApiCallback: any;
  refreshData?: boolean;
  sortBy?: string;
  id?: string;
  severity?: string;
  tableFilters?:
    | {
        [key: string]: any;
      }
    | string;
  searchQuery?: string;
  search?: string[];
  startDate?: string;
  onlyPullFirstPage?: boolean;
  noApiCallForSelect?: boolean;
  endDate?: string;
  itemsPerPage?: number;
  requestData?: any;
  isRepoOwner?: boolean;
  infiniteScroll?: boolean;
  tableId?: string;
  searchBy?: {
    id: string;
    query: string;
  }[];
  apiCall?: boolean;
}

interface ReturnProps {
  dataList: any[];
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  isNoFindings: boolean;
  total: number;
  label: string;
  supported_scm: any;
  entityType: string;
  itemsPage: number;
  page: number;
  error: any;
}

export const useGetResponseDataWithPagination = ({
  baseApiCallback,
  refreshData = false,
  sortBy,
  id,
  severity,
  isRepoOwner,
  tableFilters,
  onlyPullFirstPage,
  searchQuery,
  startDate,
  endDate,
  noApiCallForSelect,
  requestData,
  infiniteScroll,
  tableId = '',
  searchBy,
  apiCall = true,
}: Props): ReturnProps => {
  const dispatch = useDispatch();
  const [dataList, setDataList] = useState<any[]>([]);

  let pageSize = usePaginationSelector().itemsPerPage;
  let page = usePaginationSelector().page;

  // const selectedColumnFilter = useSelectedColumnSelector(tableId);
  // if (selectedColumnFilter) {
  //   pageSize = selectedColumnFilter.itemsPerPage;
  //   page = selectedColumnFilter.page;
  // }

  const [
    getDataList,
    { data, isLoading, isError, isFetching, isSuccess, error },
  ] = baseApiCallback({ id });

  useEffect(() => {
    // if (
    //   sortBy !== prevSortByValue ||
    //   // searchQuery !== prevSearchQuery ||
    //   startDate !== prevStartDate ||
    //   endDate !== prevEndDate
    // ) {
    //   dispatch(setPageNumber(1));
    //   dispatch(setItemsPerPage(10));
    //   return;
    // }

    if (
      apiCall &&
      (noApiCallForSelect === undefined || noApiCallForSelect !== true)
    ) {
      getDataList({
        pageNum: page,
        sortBy,
        id,
        tableFilters,
        searchQuery: searchQuery || undefined,
        startDate,
        isRepoOwner,
        severity,
        endDate,
        itemsPerPage: pageSize,
        searchBy,
        ...requestData,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getDataList,
    page,
    sortBy,
    id,
    tableFilters,
    searchQuery,
    startDate,
    endDate,
    pageSize,
    searchBy,
    refreshData,
    noApiCallForSelect,
    apiCall,
  ]);

  useEffect(() => {
    if (noApiCallForSelect === undefined || noApiCallForSelect !== true) {
      dispatch(setPageNumber(1));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshData, noApiCallForSelect]);

  useDeepCompareEffect(() => {
    if (
      data?.data &&
      !infiniteScroll &&
      (data?.page === page || data?.page === undefined)
    ) {
      setDataList(data.data);
    } else if (
      data?.data &&
      infiniteScroll &&
      (data?.page === page || data?.page === undefined)
    ) {
      setDataList((prevState) =>
        page === 1 ? data.data : [...prevState, ...data.data],
      );
    }
  }, [data?.data, page]);
  if (
    data?.total &&
    window.location.pathname !== '/' &&
    window.location.pathname !== '/entity-graph'
  ) {
    // if (selectedColumnFilter)
    //   dispatch(
    //     setTableTotalItems({
    //       table: tableId,
    //       total: data?.total,
    //     }),
    //   );
    // else dispatch(setTotalItems(data?.total));
    dispatch(setTotalItems(data?.total));
  }

  return {
    dataList,
    total: data?.total ?? undefined,
    itemsPage: data?.items_page ?? undefined,
    page: data?.page ?? undefined,
    label: data?.label ?? undefined,
    entityType: data?.entity_type ?? undefined,
    isLoading,
    isError,
    isFetching,
    supported_scm: data?.supported_scm ?? undefined,
    isNoFindings: isEmpty(data?.data) && isSuccess && !isLoading,
    error,
  };
};
